/**
 * exercise-template-steps.js
 */

import React from 'react';
import TourStep from '../tour-step';
import tourStepProps from '../tour-step-props';


export default [
  {
    target: "[data-testid='exercise-goal-field']",
    title: "Using Templates",
    ...tourStepProps,
    placementBeacon: 'top',
    spotlightPadding: 0,
    isFixed: true,
    content: (
      <TourStep>
        To save time with long text fields consider using a template instead.
        Templates include text samples as well as paragraphs you may have typed in previous records.
        You can use these text blocks as a starting point for your current record.
      </TourStep>
    ),
  },
  {
    target: "[data-testid='template-button']",
    title: "Using Templates",
    ...tourStepProps,
    isFixed: true,
    spotlightClicks: true,
    content: (
      <TourStep>
        It's easy to do. Just click this button to open the Choose Template dialog.
        Next, find and select the text you want and it will be added to this field.
      </TourStep>
    ),
  }
];
